// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PiXfk","label":"styles_label__3Y3Mp"};